import {Component, Input, OnChanges, TemplateRef} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import * as moment from "moment";
import {AircraftTransfer} from "../aircraft-transfer";

@Component({
	selector: "transfer-link-row",
	template: `
		<div [ngClass]="{'aircraftrow': true, 'aircraftrow-compact': compactView}">

			<div class="aircraftrow_content button-margin" (click)="navigateDetails()">
				<div class="aircraftrow_details">

					<div [ngClass]="{'aircraftrow_text': true, 'aircraftrow_text-compact': compactView}">
						<h3 class="row_text-header">
							<a *ngIf="transfer.roleInvite.isActive(loadedNow)"
							   [routerLink]="detailsUrl">{{transfer.roleInvite.uuid}}</a>
							<div *ngIf="!transfer.roleInvite.isActive(loadedNow)">{{transfer.roleInvite.uuid}}</div>
						</h3>
						<span>
							<span>Aircraft: {{aircraftIDs}}</span>
						</span>
					</div>
				</div>

				<div class="aircraftrow_statusandbuttons">
					<div *ngIf="compactView" [class]="statusClass">
						<i *ngIf="hasCheckIcon" class="fa fa-check-circle"></i>
						<i *ngIf="hasExclamationIcon" class="fa fa-exclamation-circle"></i>
						{{statusText}}
					</div>
				</div>
			</div>

			<ng-template #defaultActionButton>
			</ng-template>

			<ng-container
					[ngTemplateOutlet]="formTemplate ? formTemplate : defaultActionButton"
					[ngTemplateOutletContext]="{
					form: form,
					id: transfer.roleInvite.uuid
				}">
			</ng-container>
		</div>
	`,
	styles: [`
		:host >>> .aircraftrow_content {
			margin-right: 20px;
		}

		:host >>> .aircraftrow_details {
			width: 60%;
		}

		:host >>> .aircraftrow_text {
			width: 100%;
		}

		:host >>> .row_text-header {
			width: 25%
		}
	`],
})
export class TransferLinkRowComponent implements OnChanges {
	@Input() transfer: AircraftTransfer;
	@Input() form: FormGroup;
	@Input() formTemplate: TemplateRef<any>;
	compactView = true;
	statusClass: string;
	hasCheckIcon: boolean;
	hasExclamationIcon: boolean;
	statusText: string;
	loadedNow = moment();

	constructor (private router: Router) {}

	ngOnChanges() {
		if (this.compactView) {
			let expirationDate = moment(this.transfer.roleInvite.expireDate).diff(moment(), "days");
			let statusClass = (status: string) => `aircraftrow_status aircraftrow_status-${status}`;
			this.statusText = `${expirationDate}d`;
			if (this.transfer.roleInvite.redeemedDate != null) {
				this.statusClass = statusClass("latest");
				this.statusText = `Redeemed ${moment(this.transfer.roleInvite.redeemedDate).format("YYYY-MM-DD")}`;
			}
			else if (expirationDate > 10) {
				this.statusClass = statusClass("latest");
				this.hasCheckIcon = true;
			}
			else if (expirationDate > 0) {
				this.statusClass = statusClass("outdated");
				this.hasExclamationIcon = true;
			}
			else {
				this.statusClass = statusClass("expired");
				this.hasExclamationIcon = true;
				this.statusText = "Expired";
			}
		}
	}

	get detailsUrl() {
		return `/transfer/link/${this.transfer.roleInvite.uuid}`;
	}

	navigateDetails() {
		if (this.transfer.roleInvite.isActive(moment())) {
			this.router.navigate(["transfer", "link", this.transfer.roleInvite.uuid]);
		}
	}

	get aircraftIDs() {
		return this.transfer.aircraft.map(ac => ac.id).join(", ");
	}
}
